'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrashIcon = function TrashIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M24,7 L20.5,7 L20.5,4.5 C20.5,4.224 20.276,4 20,4 L12,4 C11.724,4 11.5,4.224 11.5,4.5 L11.5,7 L8,7 L5.5,7 C5.224,7 5,7.224 5,7.5 C5,7.776 5.224,8 5.5,8 L7.5,8 L7.5,27.5 C7.5,27.776 7.724,28 8,28 L24,28 C24.276,28 24.5,27.776 24.5,27.5 L24.5,8 L26.5,8 C26.776,8 27,7.776 27,7.5 C27,7.224 26.776,7 26.5,7 L24,7 Z M12.5,22.5 C12.5,22.776 12.276,23 12,23 C11.724,23 11.5,22.776 11.5,22.5 L11.5,11.5 C11.5,11.224 11.724,11 12,11 C12.276,11 12.5,11.224 12.5,11.5 L12.5,22.5 L12.5,22.5 Z M12.5,5 L19.5,5 L19.5,7 L12.5,7 L12.5,5 L12.5,5 Z M16.5,22.5 C16.5,22.776 16.276,23 16,23 C15.724,23 15.5,22.776 15.5,22.5 L15.5,11.5 C15.5,11.224 15.724,11 16,11 C16.276,11 16.5,11.224 16.5,11.5 L16.5,22.5 L16.5,22.5 Z M20.5,22.5 C20.5,22.776 20.276,23 20,23 C19.724,23 19.5,22.776 19.5,22.5 L19.5,11.5 C19.5,11.224 19.724,11 20,11 C20.276,11 20.5,11.224 20.5,11.5 L20.5,22.5 L20.5,22.5 Z' })
  );
};

TrashIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = TrashIcon;